module.exports = __webpack_public_path__ + "img/图1.2a6cc525.png";